// file-upload.service.js

import * as axios from 'axios';

function upload(protocolHash, formData) {
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }
    const url = process.env.VUE_APP_PROTOCOL_API + 'protocols/' + protocolHash + '/upload_image';
    return axios.post(url, formData, config).then(x => x.data)
}
export { upload }
